import React, { useState, useEffect } from "react";
import Select from "react-select";
import makeAnimated from "react-select/animated";

const animatedComponents = makeAnimated();
//  const options = [{ value: 'chocolate', label: 'Chocolate' }]

const customStyles = {
  menuPortal: (provided, state) => ({
    ...provided,
    zIndex: 999999,
    paddingTop: 0,
    marginTop: "-15px",
  }),
  minWidth: "100px",
};

export default function AnimatedMulti(props) {
  const [selected, setSelected] = useState([]);
  const [options, setOptions] = useState([
    {
      label:
        props.blankSelect && props.blankSelect !== "none" ? props.blankSelect : "Select",
      value: "",
      optionDetails: {},
      tooltip:
        props.blankSelect && props.blankSelect !== "none" ? props.blankSelect : "Select",
    },
  ]);

  useEffect(() => {
    if (Array.isArray(props.options)) {
      let opArr = [];
      if (props.blankSelect !== "none") {
        opArr.push({
          label: props.blankSelect ? props.blankSelect : "Select",
          value: "",
          optionDetails: {},
          tooltip:
            props.blankSelect && props.blankSelect !== "none"
              ? props.blankSelect
              : "Select",
        });
      }
      props.options.map((option) => {
        if (props.object) {
          opArr.push({
            label: props.object[option],
            value: option,
            optionDetails: option,
          });
        } else if (props.array) {
          opArr.push({
            label: option,
            value: option,
            optionDetails: option,
          });
        } else {
          opArr.push({
            label: option[props.KEY_label || "label"],
            value: option[props.KEY_value || "value"],
            optionDetails: option[props.KEY_value || "optionDetails"],
            tooltip: option.tooltip,
          });
        }
      });
      setOptions(opArr);
    }
  }, [props.options]);

  useEffect(() => {
    // if (props.value) {
    let ds = options.filter((obj) => props.value === obj.value);
    setSelected(ds);
    // }
  }, [props.value, options]);

  const onChange = (ob) => {
    if (props.onChange) {
      let e = {
        target: {
          value: ob?.value,
          name: props.name ? props.name : "",
          optionDetails: ob.optionDetails ? ob.optionDetails : {},
        },
      };
      props.onChange(e);
    }
  };

  return (
    <div>
      <Select
        value={selected}
        menuPlacement={props.menuPlacement ? props.menuPlacement : "bottom"}
        closeMenuOnSelect={true}
        components={props.component ? { Option: props.component } : animatedComponents}
        // defaultValue={selected}
        options={options}
        onChange={onChange}
        placeholder={props.placeholder ? props.placeholder : "Select..."}
        isDisabled={props.disabled ? props.disabled : false}
        style={props.style ? props.style : {}}
        menuPortalTarget={
          props.menuPortalTarget === null ? props.menuPortalTarget : document.body
        }
        className={`customDropdown ${props.className ? props.className : ""}`}
        classNamePrefix={"codefire"}
        styles={props.customStyles ? customStyles : {}}
        // menuIsOpen={true}
      />
    </div>
  );
}

export const SearchableSelect = AnimatedMulti;
